import { TransText } from '@/i18n/trans/text';
import { breakpoints } from '@/utils/breakpoints';
import { Button, Icons, Popover, Sheet } from '@fleet/webshop-ui';
import { type FC, type ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';

interface MakeChangesProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  trigger?: ReactNode;
  onEditPassengerDetailsClick: () => void;
}

const MakeChanges: FC<MakeChangesProps> = ({
  isOpen,
  onOpenChange,
  trigger,
  onEditPassengerDetailsClick,
}) => {
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });

  const handleEditPassengerDetails = () => {
    onEditPassengerDetailsClick();
    onOpenChange(false);
  };

  const menuContent = (
    <div className="flex flex-col gap-2">
      <Button
        variant="secondary"
        onClick={handleEditPassengerDetails}
        className="justify-center"
        data-testid="make-changes-edit-passengers"
      >
        <Icons.edit width={20} height={20} />
        <TransText i18nKey="editPassengerDetails" />
      </Button>
    </div>
  );

  if (isLaptopOrBigger) {
    return (
      <Popover
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        trigger={trigger}
        data-testid="make-changes-popover"
        placement="top"
        content={menuContent}
        className={{ root: 'w-64' }}
      />
    );
  }

  return (
    <Sheet
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      trigger={trigger}
      side="bottom"
      headerTitle={<TransText i18nKey="makeChanges" />}
      className={{ root: 'min-w-full' }}
      data-testid="make-changes-sheet"
    >
      {menuContent}
    </Sheet>
  );
};

export default MakeChanges;
